import React from 'react';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { DropDownChonStateXuLyDon, DropDownChonPhongBanThuocCoQuan, DropDownChonCanBoXuLy } from 'components/tt-forms';
import { processType } from 'constants/process-type';
import { validatable } from 'components/utils';
import { GiaiQuyetDonThu } from 'api';
import { msg } from "constants/message";

const process = [processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong, processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien];

class LanhDaoGiaoViecKTDXPU extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_GiaoViecTruongPhongKTDX: false,
      form_GiaoViecCanBoKTDX: false,

      donId: this.props.donId,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      noiDung: '',
      phongBanGiaiQuyet: '',
      truongPhongChiDinh: '',
      canBoChiDinh: '',

    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {

      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {
          case 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG':
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_GiaoViecTruongPhongKTDX: true
            });
          break;

          case 'LANH_DAO_GIAO_VIEC_CAN_BO':
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_GiaoViecCanBoKTDX: true
            });
          break;
          default: break;
        }
      }
    });
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {

    GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(res => {
      if (res.data) {
        let info = res.data;

        this.setState({
          dataGiaiQuyetDon: info,
          nextState: info.nextStateInfo ? info.nextStateInfo.type : '',
          phongBanGiaiQuyet: info.nextStateInfo && info.phongBanGiaiQuyetInfo ? info.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
          truongPhongChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
          canBoChiDinh: info.nextStateInfo && info.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' && info.canBoXuLyChiDinhInfo ? info.canBoXuLyChiDinhInfo.congChucId : '',
          noiDung: info.yKienGiaiQuyet ? info.yKienGiaiQuyet : '',
        });
      }
    }).then(() => {
      this.onlyOneState()
    });
  }

  onlyOneState() {

    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState));
    } else {
      this.trigger(this.state);
    }
  }

  handleChange(name, e) {

    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    if (name == 'nextState') {



      if (this.state.donId == 0) {
        newState = {
          ...newState,
          phongBanGiaiQuyet: '',
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        }
      }

    } else if (name == 'phongBanGiaiQuyet') {

      newState = {
        ...newState,
        truongPhongChiDinh: '',
        canBoChiDinh: ''
      }
    }

    this.setState({
      ...newState
    }, this.trigger(newState));
  }

  trigger(newState) {

    if (newState.nextState) {

      let stateId = this.props.getState(this.props.listNextStates, newState.nextState);

      let paramsPatch = this.state.dataGiaiQuyetDon;
      let paramsPost = {};

      paramsPatch.nextState = {
        id: Number(stateId),
        type: newState.nextState
      }

      paramsPost.nextState = {
        id: Number(stateId),
        type: newState.nextState
      }

      paramsPatch.yKienGiaiQuyet = newState.noiDung;
      paramsPost.yKienGiaiQuyet = newState.noiDung;

      if (newState.phongBanGiaiQuyet) {

        paramsPatch.phongBanGiaiQuyet = {
          id: Number(newState.phongBanGiaiQuyet)
        }
        paramsPost.phongBanGiaiQuyet = {
          id: Number(newState.phongBanGiaiQuyet)
        }
      }

      if (newState.form_GiaoViecTruongPhongKTDX && newState.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG') {

        if (newState.truongPhongChiDinh) {
          paramsPatch.canBoXuLyChiDinh = {
            id: Number(newState.truongPhongChiDinh)
          }
          paramsPost.canBoXuLyChiDinh = {
            id: Number(newState.truongPhongChiDinh)
          }
        }
      } else if (newState.form_GiaoViecCanBoKTDX && newState.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO') {

        if (newState.canBoChiDinh) {
          paramsPatch.canBoXuLyChiDinh = {
            id: Number(newState.canBoChiDinh)
          }
          paramsPost.canBoXuLyChiDinh = {
            id: Number(newState.canBoChiDinh)
          }
        }
      }

      paramsPost.thongTinGiaiQuyetDon = {
        id: this.props.thongTinGiaiQuyetDonId
      }

      let params = {
        paramsPatch: paramsPatch,
        paramsPost: paramsPost,
        notice: msg.ktdxLanhDaoGiaoViec
      }

      this.props.onChange(params);
    }
  }

  render() {
    return (
      <div className="body-dialog-gh">
        <span className='col-100 text-13 pt25 pl20 pb10'>{this.props.content}</span>
        <div className="row pl30 pr30 pt20">
          <ShowIf condition={!this.state.hideDropdown}>
            <DropDownChonStateXuLyDon require
              className="col-50"
              value={this.state.nextState}
              label="Giao xử lý"
              onChange={this.handleChange.bind(this, 'nextState')}
              data={this.props.listNextStates}
              isValid={this.props.validate}
              bindValidator={this}
              name="dropdownHuongXuLy" />
          </ShowIf>

          <ShowIf condition={(this.state.form_GiaoViecTruongPhongKTDX && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG') ||
            (this.state.form_GiaoViecCanBo && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO')}>
            <DropDownChonPhongBanThuocCoQuan require
            className="col-50"
              bindValidator={this}
              selectedValue={this.state.phongBanGiaiQuyet}
              isValid={this.props.validate}
              onChange={this.handleChange.bind(this, 'phongBanGiaiQuyet')}
              name="dropdownChonPhongBanThuocCoQuan" />
          </ShowIf>

          <ShowIf condition={this.state.form_GiaoViecTruongPhongKTDX
            && this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG'
            && this.state.phongBanGiaiQuyet != ''}>
            <DropDownChonCanBoXuLy
              label="Lãnh đạo phòng"
              className="col-50"
              vaiTro="TRUONG_PHONG"
              selectedValue={this.state.truongPhongChiDinh}
              phongBanId={this.state.phongBanGiaiQuyet}
              onChange={this.handleChange.bind(this, 'truongPhongChiDinh')}
              name="dropdownChonCanBoXuLyTruongPhong" />
          </ShowIf>

          <ShowIf condition={this.state.form_GiaoViecCanBoKTDX
            && this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO'
            && this.state.phongBanGiaiQuyet != ''}>
            <DropDownChonCanBoXuLy require
              bindValidator={this}
              className="col-50"
              vaiTro="CHUYEN_VIEN"
              selectedValue={this.state.canBoChiDinh}
              phongBanId={this.state.phongBanGiaiQuyet}
              onChange={this.handleChange.bind(this, 'canBoChiDinh')}
              name="dropdownChonCanBoXuLyChuyenVien" />
          </ShowIf>
        </div>
      </div>
    );
  }
}

LanhDaoGiaoViecKTDXPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  }
}

function bindStateToProps(state) {
  return {
    dataThongTinXuLyGiaiQuyet: state.formDataTiepCongDan.thongTinXuLyGiaiQuyet
  }
}

export default connect(bindStateToProps)(validatable(LanhDaoGiaoViecKTDXPU));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/thu-hoi-form/LanhDaoGiaoViecKTDXPU.jsx